<template>
  <div
    class="q-wrap pc-wrap vh-q-sdk"
    :class="{isReplayPc: isReplay}"
    v-show="show"
  >
    <div class="vhall-question-title" v-if="enable_banner != 0">
      <img :src="headerImg" alt="" />
    </div>

    <div v-if="config.showMyReward" style="text-align: right">
      <div @click="handleMyReward" class="reward-button" v-on="$listeners">
        <i class="reward-button__icon"></i>
        <span class="reward-button__txt">{{ $t("form.form_1091") }} </span>
      </div>
    </div>

    <div v-if="q.title" class="q-title" v-text="q.title"></div>
    <div
      v-if="q.description"
      id="introDes"
      :class="['q-des', overflowStatus == 1 ? 'introEllipsis' : '']"
    >
      {{ q.description }}
      <span
        @click="handleUnfold(2)"
        class="textTail"
        v-show="overflowStatus == 1"
      >
        <span class="isEllipsis">... </span>{{ $t("form.form_1011") }}
      </span>
      <span
        @click="handleUnfold(1)"
        class="textTail"
        v-show="overflowStatus == 2"
      >
        <span class="isEllipsis"></span>{{ $t("form.form_1012") }}
      </span>
    </div>
    <!-- <div class="q-split"></div> -->
    <div class="q-list">
      <com-question
        :ref="`com${index}`"
        v-for="(item, index) in q.detail"
        :detail="q.detail"
        :value.sync="item"
        :isReplay="isReplay"
        :key="index"
      ></com-question>
    </div>
    <!-- 隐私协议 -->
    <qPrivacy
      v-if="privacyData.privacyConten"
      ref="qPrivacy"
      :privacyData="privacyData"
      :isPreview="true"
    ></qPrivacy>
    <div
      :class="['q-btns', showVhPrivacy ? 'q-btns__privacy' : '']"
      v-if="!config.isPreview && !isReplay"
    >
      <vh-button
        class="vhall-btn-primary"
        id="ques_sdk_sub_btn"
        @click="doSubmit"
        >{{ $t("form.form_1045") }}</vh-button
      >
    </div>
    <!-- 隐私协议 -->
    <!-- <div :class="['q-privacy', i18nLocal == 'en' ? 'language__en' : '']"
      v-if="showVhPrivacy">
      <i18n path="privacy.privacy_1002">
        <span place="n">
          <a :href="privacyUrl"
            target="_blank"
            rel="noopener noreferrer">
            {{ $t('privacy.privacy_1004') }}
          </a>
        </span>
        <span place="n1">
          <a :href="privacyUPoUrl"
            target="_blank"
            rel="noopener noreferrer">
            {{ $t('privacy.privacy_1003') }}
          </a>
        </span>
      </i18n>
    </div> -->
  </div>
</template>

<script>
import Questionnaire from "src/model/questionnaire";
import question from "../components/questionnaire/wrap.vue";
import CONST from "src/model/const";
import qPrivacy from "../components/q-privacy.vue";
import {PRIVACY_POLICY, PRIVACY_UPO} from "src/utils/conf";
import imgOperateMixin from "./mixins/img_operate";
export default {
  components: {
    comQuestion: question,
    qPrivacy,
  },
  mixins: [imgOperateMixin],
  provide() {
    return {
      sdk: this.sdk,
      defaultPhone: this.defaultPhone,
      isPreview: true,
      isH5: false,
      id: this.id,
      i18nLocal: this.i18nLocal,
      webinarId: this.webinarId,
      businessUid: this.businessUid,
    };
  },
  props: {
    id: [String, Number],
    sdk: Object,
    notify: Boolean,
    defaultPhone: [String, Number],
    config: {
      type: Object,
      default: {
        isPreview: false,
        isPc: true,
        showMyReward: false,
      },
    },
    showVhPrivacy: Boolean,
    i18nLocal: String,
    tpSubmit: {
      default: false,
    }, // 是否第三方提交，如果true则提交交给第三方处理
    webinarId: [Number, String],
    businessUid: [Number, String],
  },
  data() {
    return {
      show: false,
      overflowStatus: 0,
      defaultImg: require("./signup-form/form-head-new1.png"),
      q: new Questionnaire(),
      headerImg: "",
      privacyUrl: PRIVACY_POLICY,
      privacyUPoUrl: PRIVACY_UPO,
      privacyData: {},
      enable_banner: true,
      isReplay: false,
    };
  },
  created() {
    if (this.id) {
      this.sdk.getById(this.id).then((res) => {
        console.log("接口返回数据", res);
        if (res.code !== 200) {
          this.$emit(CONST.EVENT.ERROR, res);
          if (this.notify) {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          return;
        }
        this.q = new Questionnaire(res.data);
        console.log(this.q, this.config);
        let replayData = this.config.replayData;
        if (replayData && replayData.length > 0) {
          this.isReplay = true;
          for (let i = 0; i < replayData.length; i++) {
            for (let j = 0; j < this.q.detail.length; j++) {
              if (replayData[i].question_id == this.q.detail[j].id) {
                this.q.detail[j].replayData = replayData[i].answer;
                break;
              }
            }
          }
        } else {
          this.isReplay = false;
        }
        this.headerImg = this.imgOperate();
        this.$forceUpdate();
        this.q.title = res.data.title;
        this.show = true;
        console.log(this.q, this.isReplay);
        this.$nextTick(() => {
          this.calculateText();
        });
        try {
          if (!res.data.extension) return;
          this.privacyData = JSON.parse(res.data.extension);
          this.enable_banner = this.privacyData.enable_banner;
          // undefined 为历史数据兼容
          if (
            this.privacyData.privacyRadio == 1 ||
            this.privacyData.privacyRadio == undefined
          ) {
            this.privacyData.privacyConten = this.$t("privacy.privacy_1006");
            this.privacyData.details = [
              {
                name: this.$t("privacy.privacy_1004"),
                url: PRIVACY_POLICY,
              },
              {
                name: this.$t("privacy.privacy_1003"),
                url: PRIVACY_UPO,
              },
            ];
          }
        } catch (err) {
          console.log(err);
        }
      });
    }
  },
  methods: {
    async doSubmit() {
      let result = true;
      let data = {};
      let emitObj = {
        report: [],
      };
      // 检查协议勾选情况
      // if(!this.$refs.qPrivacy.privacyChecked){
      //   result = false;
      //   this.$refs.qPrivacy.check()
      //   return false;
      // }
      // 排除qPrivacy组件
      let keys = Object.keys(this.$refs).filter((item) => item != "qPrivacy");
      for (let i = 0, len = keys.length; i < len; i++) {
        let _data = await this.$refs[keys[i]][0].check();
        console.log(_data, "_dataphone");
        if (!_data) {
          const target = this.$refs[keys[i]][0].$el;
          target.scrollIntoView({
            behavior: "smooth",
          });
          result = false;
          break;
        }
        if (_data.id) {
          if (_data.keyVal) {
            data[_data.id] = _data.keyVal;
          } else {
            data[_data.id] = _data.value;
          }
          // 其他选项
          // if(_data.otherValue){
          //   data[_data.keyVal||_data.value] = _data.otherValue
          // }
          emitObj.report.push(_data);
        }
      }
      if (result) {
        let _data = {
          naire_id: this.id, // 问卷id
          id: this.id, // 问卷id
          answer: JSON.stringify(data),
        };
        console.log(emitObj, 88);
        // 如果是第三方提交，则只负责抛出消息
        if (this.tpSubmit) {
          this.$emit(CONST.EVENT.SUBMIT, _data);
          return;
        }
        this.sdk
          .submit(_data)
          .then((res) => {
            if (res.code === 200) {
              // 提交的时候除了返回参数还要是返回接口返回值
              this.$emit(
                CONST.EVENT.SUBMIT,
                Object.assign(_data, emitObj, res || {})
              );
              if (this.notify) {
                this.$message({
                  message: this.$t("form.form_1088"),
                  type: "success",
                });
              } else {
                this.$message({
                  message: this.$t("form.form_1087"),
                  type: "success",
                });
              }
            } else {
              this.$emit(CONST.EVENT.ERROR, res);
              if (this.notify) {
                this.$message({
                  message: this.$t("register.register_1004"),
                  type: "error",
                });
              }
            }
          })
          .catch((error) => {
            this.$emit(CONST.EVENT.ERROR, error);
            if (this.notify) {
              this.$message({
                message: "服务器端错误",
                type: "error",
              });
            }
          });
      }
    },
    handleUnfold(val) {
      this.overflowStatus = val;
    },
    calculateText() {
      const txtDom = document.getElementById("introDes");
      if (!txtDom) return false;
      const twoHeight = 40;
      const curHeight = txtDom.offsetHeight;
      if (curHeight > twoHeight) {
        this.overflowStatus = 1;
      }
    },
    // 互动有礼，查看我的礼品
    handleMyReward() {
      this.$emit(CONST.EVENT.MYREWARD);
    },
  },
};
</script>

<style scoped lang="scss">
.q-wrap {
  width: 100%;
  height: 100%;
  overflow: auto;
  font-size: 16px;

  .vhall-btn-primary {
    border: 1px solid #fb3a32;
    width: 158px;
    height: 40px;
    line-height: 40px;
    border-radius: 2px;
    background-color: #fb3a32;
    font-size: 12px;
    color: #fff;
    outline: none;
    display: block;
    margin: 0 auto;
    padding: 0;
    text-decoration: none;
    border-radius: 20px;
    cursor: pointer;
    &:hover {
      background-color: #fc5659;
      border-color: #fc5659;
    }
  }
  .vhall-question-title {
    height: 120px;
    width: 100%;
    border-radius: 4px 4px 0 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: fill;
    }
    /*background: url('./signup-form/form-head-new1.png');*/
    /*background: url('//cnstatic01.e.vhall.com/static/images/questionnaire/show-header.png?v=BTc%2FbE46UqLn3cbkqbEFDQ%3D%3D');*/
    /*background-size: 100% 100%;*/
  }
  .q-list {
    padding: 0 55px;
    color: #1a1a1a;
    font-family: "-apple-system", "BlinkMacSystemFon", "Helvetica Neue",
      Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
      "微软雅黑", Arial, sans-serif;
  }
  ::v-deep {
    * {
      box-sizing: border-box;
    }
    .index {
      line-height: 18px;
    }
    .q-title {
      text-align: center;
      /*padding: 18px 0 10px 0;*/
      margin-top: 20px;
      font-size: 22px;
      color: #333;
      word-wrap: break-word;
      white-space: normal;
      word-break: break-all;
      line-height: 33px;
      padding: 0 75px;
      margin-bottom: 20px;
      font-family: "-apple-system", "BlinkMacSystemFon", "Helvetica Neue",
        Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
        "微软雅黑", Arial, sans-serif;
    }
    .q-des {
      /*text-align: center;*/
      font-size: 14px;
      color: #333;
      word-break: break-all;
      margin: 0 75px;
      font-family: "-apple-system", "BlinkMacSystemFon", "Helvetica Neue",
        Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei",
        "微软雅黑", Arial, sans-serif;
      line-height: 20px;
      position: relative;
      &.introEllipsis {
        word-break: break-all;
        text-overflow: ellipsis;
        display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
        -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
        -webkit-line-clamp: 2; /** 显示的行数 **/
        overflow: hidden; /** 隐藏超出的内容 **/
      }
      .textTail {
        position: absolute;
        bottom: 0px;
        right: 0px;
        cursor: pointer;
        background-color: #fff;
        color: #3562fa;
        .isEllipsis {
          color: #666666;
        }
      }
    }
    .q-split {
      height: 16px;
      border-bottom: 2px solid #dadada;
      margin-bottom: 15px;
    }
    .question-wrap {
      border: 0;
    }
    .q-btns {
      width: 100%;
      height: 100px;
      line-height: 100px;
      margin-top: 30px;
      text-align: center;
      font-size: 12px;
      &.q-btns__privacy {
        line-height: unset;
        height: unset;
        .vh-button {
          margin: 20px auto 12px auto;
        }
      }
    }
    // .q-privacy {
    //   margin: 0 auto 60px auto;
    //   text-align: center;
    //   padding: 0 20px;
    //   span,
    //   a {
    //     font-style: normal;
    //     font-weight: 400;
    //     font-size: 12px;
    //     line-height: 16px;
    //     color: #8c8c8c;
    //     word-break: break-word;
    //   }
    //   a {
    //     text-decoration: none;
    //     font-weight: 400;
    //     color: #3562fa;
    //     transform: matrix(0.99, 0, -0.14, 1, 0, 0);
    //     &:hover {
    //       color: #3562fa;
    //     }
    //   }
    //   &.language__en {
    //     text-align: center;
    //     a {
    //       font-style: italic;
    //     }
    //   }
    // }
    @media (min-width: 375px) {
      .q-privacy {
        margin-top: 18px;
        text-align: center;
      }
    }
  }
}
::v-deep {
  .select {
    display: flex;
    justify-content: space-between;
    width: 100%;
    // .vhall-inline {
    //   width: 32%;
    // }
  }
}
</style>
<style lang="scss">
.q-wrap {
  .q-edit-content {
    &.radio-content {
      .row.display {
        margin-bottom: 6px;
      }
    }
    .q-select-item {
      .item-text.check-item {
        line-height: 22px !important;
        margin-top: 3px;
      }
    }
    .vh-checkbox.display {
      margin-bottom: 8px;
    }
  }
  .question-content {
    .item-text {
      margin-top: 12px;
    }
  }

  .input-mobile {
    margin-top: 10px;
  }
  .checkbox-items {
    margin-top: 3px;
  }
}
.pc-wrap.q-wrap {
  .vh-radio__input {
    margin-top: 12px !important;
  }
}
</style>
<style lang="scss">
.q-wrap {
  &.isReplayPc {
    .vh-radio__input.is-disabled .vh-radio__inner,
    .vh-checkbox__input.is-disabled .vh-checkbox__inner {
      background-color: #fff;
    }
    .vh-radio__input.is-disabled + span.vh-radio__label,
    .vh-checkbox__input.is-disabled + span.vh-checkbox__label {
      color: #c2c2c2;
    }
    .vh-input.is-disabled .vh-input__inner {
      background-color: #fff;
      color: #c2c2c2;
    }
  }
}
</style>
<style lang="scss" scoped>
.reward-button {
  margin-top: 10px;
  box-sizing: border-box;
  position: relative;
  display: inline-flex;
  align-items: center;
  padding: 4px 12px;
  border-top-left-radius: 30px;
  border-bottom-left-radius: 30px;
  background-color: rgba(0, 0, 0, 0.25);
  cursor: pointer;
  color: #fff;

  &__icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA4CAYAAACohjseAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAHtSURBVHgB7ZqBcYIwFIb/eB3ATtBsUDeoHaEb2AnqBtIJtBNoN3ADdQLdQDbQDV5fDqgQIyDWyLP57v5Dj4S8nyQ8SQQCgcDdQUQ9lm5Qp4e2w0GO6cCoZp1prs4QbYaOGVWUn1rl52gzHOCirkmHORE92GWtq0yeMBdBAlUmRZvLKDG5Fm8uo8SkN3Oq7CQleenS3NRljdKjzYb1hcvYGymllrVrUJJ0tySLLWtge1EOc5oPa7jvuATeuDd/c2nHUSCCXHOGQjp6cBR4zn2OWZ9oPx84PCvM9OpyL+6dJak49xYQAMc5s+ajzs51cOdUGZQyF0/G6ZqDMUunn814JsjC5MQ4++LqwW/Ipjp+7rSIZLJgFYarKjHZ58OA9cTq506Zx+8G52Mazv/si1Odi8ZhCiGNxWjFQ3OGJlh3aYoGmBtmXSdCA+h4dPXLyv/7NCGeYFA6waB0gkHpBIPSCQal49OgvQgUwwPeDPKrTH4Ve5nq6ngdomxyqBJe88sK1yTMQekEg9IJBh084t6g4obMzl579ByLvSV+eSx8kYl1UdOIhkco2e8f23FU1VOoAZ3e9V3CD6ZdjeP23xsv9tqwySG1iwn+GkpM7uj21DZXa4haJjWSPYsXFPcIro15G1mx5mf9ZSQQCNyUHxPwr3gxpTnCAAAAAElFTkSuQmCC");
  }

  &__txt {
    font-size: 14px;
    margin-left: 4px;
  }
}
</style>
